module.exports = __webpack_public_path__ + "static/img/icon_szh_cgal_gk_zdzc@2x.ce2837ec.png";